.container {
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  width: 100%;
  min-width: 0;
}

.periodSelectorBar {
  background: linear-gradient(135deg, #ffffff 0%, #eff4ff 100%);
  border: 1px solid #dce9ff;
  border-radius: 14px;
  padding: 0.9rem 1.15rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  box-shadow: 0 2px 10px rgba(13, 28, 46, 0.04);
}

.periodSelectorInfo {
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}

.periodSelectorTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.9rem;
  font-weight: 800;
  color: #00236f;
  letter-spacing: -0.01em;
}

.periodSelectorHint {
  font-size: 0.75rem;
  color: #444651;
}

.periodControlsGroup {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.periodSelect {
  background: #ffffff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 9px;
  padding: 0.55rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 700;
  min-width: 240px;
}

.periodSelect:focus {
  outline: none;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.12);
}

.manualExpenseCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.05);
}

.manualCardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.manualCardTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.98rem;
  font-weight: 800;
  color: #00236f;
  margin: 0;
  letter-spacing: -0.015em;
}

.manualCardSubtitle {
  font-size: 0.76rem;
  color: #444651;
  margin: 0.16rem 0 0 0;
  line-height: 1.38;
}

.toggleManualFormBtn {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  color: #00236f;
  border-radius: 8px;
  padding: 0.42rem 0.75rem;
  font-size: 0.76rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.toggleManualFormBtn:hover {
  background: #e6eeff;
  border-color: #00236f;
}

.manualFormGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  padding-top: 0.65rem;
  border-top: 1px dashed #dce9ff;
}

.manualField {
  display: flex;
  flex-direction: column;
  gap: 0.26rem;
}

.manualLabel {
  font-size: 0.71rem;
  font-weight: 700;
  color: #444651;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.manualInput,
.manualSelect {
  width: 100%;
  background: #f8f9ff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.5rem 0.68rem;
  font-size: 0.82rem;
  font-variant-numeric: tabular-nums;
}

.manualInput:focus,
.manualSelect:focus,
.manualInputSmall:focus {
  outline: none;
  background: #ffffff;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.manualInlineInputs {
  display: grid;
  grid-template-columns: 115px 1fr;
  gap: 0.45rem;
}

.manualInputSmall {
  width: 100%;
  background: #f8f9ff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 8px;
  padding: 0.5rem 0.55rem;
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
}

.manualFormFooter {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.65rem;
  padding-top: 0.35rem;
}

.manualPeriodStatus {
  font-size: 0.76rem;
}

.periodPillActive {
  color: #005049;
  background: #e6f7f5;
  border: 1px solid #86f2e4;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  display: inline-block;
}

.periodPillExternal {
  color: #004469;
  background: #eff4ff;
  border: 1px solid #cce5ff;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  display: inline-block;
}

.manualSubmitBtn {
  padding: 0.62rem 1.05rem;
  border-radius: 9px;
  border: none;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-weight: 800;
  font-size: 0.83rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.2);
}

.headerCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.2rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.05);
  min-width: 0;
}

.headerTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.eyebrow {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #004469;
  display: block;
  margin-bottom: 0.2rem;
}

.title {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.14rem;
  font-weight: 800;
  color: #00236f;
  margin: 0;
  line-height: 1.28;
  letter-spacing: -0.02em;
}

.subtitle {
  font-size: 0.8rem;
  color: #444651;
  margin: 0.22rem 0 0 0;
  line-height: 1.4;
}

.kpiSummaryGrid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8rem;
  width: 100%;
  min-width: 0;
}

.kpiBox {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 12px;
  padding: 0.85rem 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 0.26rem;
  min-width: 0;
}

.kpiLabel {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #444651;
  line-height: 1.25;
}

.kpiMainValue {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.08rem;
  font-weight: 800;
  color: #0d1c2e;
  font-variant-numeric: tabular-nums;
  white-space: normal;
  word-break: break-word;
  line-height: 1.25;
  letter-spacing: -0.02em;
}

.kpiSubValue {
  font-size: 0.76rem;
  color: #006a61;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
  font-variant-numeric: tabular-nums;
}

.kpiMeta {
  font-size: 0.72rem;
  color: #444651;
  line-height: 1.35;
  word-break: break-word;
  font-variant-numeric: tabular-nums;
}

.chartsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.1rem;
  width: 100%;
  min-width: 0;
}

.chartCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.15rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  min-width: 0;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.04);
}

.chartHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.chartTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.98rem;
  font-weight: 800;
  color: #00236f;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.015em;
}

.chartSubtitle {
  font-size: 0.77rem;
  color: #444651;
  margin: 0.15rem 0 0 0;
  line-height: 1.38;
}

.chartPill {
  font-size: 0.68rem;
  font-weight: 700;
  color: #00236f;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 999px;
  padding: 0.2rem 0.58rem;
  white-space: nowrap;
}

/* Donut + Leyenda Categorías */
.donutLayout {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  min-width: 0;
}

.donutSvgWrapper {
  position: relative;
  width: 142px;
  height: 142px;
  flex-shrink: 0;
  margin: 0 auto;
}

.donutCenterLabel {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;
  padding: 0 0.5rem;
}

.donutCenterTitle {
  font-size: 0.62rem;
  text-transform: uppercase;
  color: #444651;
  font-weight: 700;
}

.donutCenterAmount {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.86rem;
  font-weight: 800;
  color: #00236f;
  font-variant-numeric: tabular-nums;
}

.categoryBarsList {
  flex: 1;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.barRowItem {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  min-width: 0;
}

.barRowTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 0.8rem;
}

.barNameGroup {
  display: flex;
  align-items: center;
  gap: 0.42rem;
  flex-wrap: wrap;
  min-width: 0;
  flex: 1;
}

.colorDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.barLabelText {
  font-weight: 700;
  color: #0d1c2e;
  white-space: normal;
  word-break: break-word;
  line-height: 1.28;
}

.barAmountText {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-weight: 800;
  color: #00236f;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.barTrack {
  width: 100%;
  height: 8px;
  background: #e6eeff;
  border-radius: 999px;
  overflow: hidden;
}

.barFill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.3s ease;
}

.barMetaRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  flex-wrap: wrap;
  font-size: 0.72rem;
  color: #444651;
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
}

.rucBadge {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-mono, monospace);
  font-size: 0.66rem;
  font-weight: 700;
  color: #004469;
  background: #eff4ff;
  border: 1px solid #cce5ff;
  border-radius: 5px;
  padding: 0.1rem 0.4rem;
  font-variant-numeric: tabular-nums;
}

.inevitableTag {
  display: inline-flex;
  align-items: center;
  font-size: 0.66rem;
  font-weight: 700;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 5px;
  padding: 0.12rem 0.45rem;
}

/* Sección de Impacto de Producto o Servicio Consumido */
.productImpactSection {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.15rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  min-width: 0;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.04);
}

.productSpotlightGrid {
  display: grid;
  grid-template-columns: 1.05fr 1.35fr;
  gap: 1rem;
  align-items: start;
  min-width: 0;
}

.spotlightCard {
  background: linear-gradient(145deg, #f8f9ff 0%, #eff4ff 100%);
  border: 1px solid #dce9ff;
  border-radius: 14px;
  padding: 0.95rem 1.05rem;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  min-width: 0;
}

.selectLabel {
  font-size: 0.71rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #00236f;
  line-height: 1.3;
}

.selectInput {
  width: 100%;
  max-width: 100%;
  background: #ffffff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 9px;
  padding: 0.55rem 0.7rem;
  font-size: 0.82rem;
  font-weight: 600;
}

.spotlightStatsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
  min-width: 0;
}

.spotlightMetricBox {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.62rem 0.72rem;
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
  min-width: 0;
}

.spotlightMetricVal {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.98rem;
  font-weight: 800;
  color: #0d1c2e;
  font-variant-numeric: tabular-nums;
  word-break: break-word;
}

.spotlightNarrative {
  font-size: 0.77rem;
  color: #0d1c2e;
  line-height: 1.45;
  background: #ffffff;
  border-left: 3px solid #006a61;
  border-top: 1px solid #dce9ff;
  border-right: 1px solid #dce9ff;
  border-bottom: 1px solid #dce9ff;
  padding: 0.55rem 0.72rem;
  border-radius: 6px;
  margin: 0;
}

/* Lista completa de Gastos Realizados */
.ledgerCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 16px;
  padding: 1.15rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
  min-width: 0;
  box-shadow: 0 4px 18px rgba(13, 28, 46, 0.05);
}

.filterRow {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.searchInput {
  flex: 1;
  min-width: 180px;
  width: 100%;
  background: #f8f9ff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 9px;
  padding: 0.55rem 0.8rem;
  font-size: 0.82rem;
}

.searchInput:focus,
.filterSelect:focus {
  outline: none;
  background: #ffffff;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.filterSelect {
  background: #f8f9ff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 9px;
  padding: 0.55rem 0.75rem;
  font-size: 0.8rem;
  max-width: 100%;
}

.scanShortcutBtn {
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  border: none;
  border-radius: 9px;
  padding: 0.52rem 0.95rem;
  font-size: 0.78rem;
  font-weight: 800;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 35, 111, 0.2);
}

.expenseList {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.expenseRowCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 14px;
  padding: 0.9rem 1.05rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  min-width: 0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.expenseRowCard:hover {
  border-color: #b4c8ff;
  box-shadow: 0 4px 14px rgba(13, 28, 46, 0.05);
}

.expenseRowWithReceipt {
  border-color: #b4c8ff;
  background: linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%);
}

.expenseRowMain {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
}

.receiptThumbColumn {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.receiptThumbButton {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.24rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.22rem;
  width: 86px;
  transition: transform 0.16s ease, border-color 0.16s ease;
}

.receiptThumbButton:hover {
  transform: translateY(-2px);
  border-color: #00236f;
}

.receiptThumbImg {
  width: 76px;
  height: 92px;
  object-fit: cover;
  border-radius: 6px;
  background: #e6eeff;
  display: block;
}

.receiptThumbCaption {
  font-size: 0.62rem;
  font-weight: 800;
  color: #00236f;
  text-align: center;
  line-height: 1.15;
}

.receiptPlaceholderButton {
  background: #f8f9ff;
  border: 1px dashed #93b4ff;
  border-radius: 10px;
  padding: 0.45rem 0.35rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.18rem;
  width: 86px;
  min-height: 108px;
}

.receiptPlaceholderIcon {
  font-size: 1.35rem;
}

.receiptPlaceholderText {
  font-size: 0.64rem;
  font-weight: 800;
  color: #0d1c2e;
}

.expenseLeft {
  display: flex;
  flex-direction: column;
  gap: 0.38rem;
  min-width: 0;
  flex: 1;
}

.expenseTitleRow {
  display: flex;
  align-items: center;
  gap: 0.42rem;
  flex-wrap: wrap;
}

.expenseMerchant {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.94rem;
  font-weight: 800;
  color: #0d1c2e;
  word-break: break-word;
}

.receiptNumberBadge {
  display: inline-flex;
  align-items: center;
  font-family: var(--font-mono, monospace);
  font-size: 0.66rem;
  font-weight: 700;
  color: #006a61;
  background: #e6f7f5;
  border: 1px solid #86f2e4;
  border-radius: 5px;
  padding: 0.1rem 0.44rem;
  font-variant-numeric: tabular-nums;
}

.controllableTag {
  display: inline-flex;
  align-items: center;
  font-size: 0.65rem;
  font-weight: 700;
  color: #00236f;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 5px;
  padding: 0.1rem 0.42rem;
}

.sourcePill {
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.12rem 0.44rem;
  border-radius: 5px;
  background: #e6f7f5;
  color: #006a61;
  border: 1px solid #86f2e4;
}

.sourcePillRecurring {
  background: #eff4ff;
  color: #004469;
  border: 1px solid #cce5ff;
}

.sourcePillManual {
  background: #f0f4ff;
  color: #1e3a8a;
  border: 1px solid #dce9ff;
}

.expenseDetailPillsRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.detailMetaPill {
  font-size: 0.74rem;
  color: #444651;
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 6px;
  padding: 0.18rem 0.5rem;
  line-height: 1.3;
  word-break: break-word;
  font-variant-numeric: tabular-nums;
}

.detailMetaPill strong {
  color: #0d1c2e;
}

.expenseSubMetaRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.55rem;
}

.expenseSubMeta {
  font-size: 0.75rem;
  color: #444651;
  line-height: 1.35;
  word-break: break-word;
}

.editDateInlineBtn {
  padding: 0.18rem 0.48rem;
  border-radius: 5px;
  border: 1px solid #dce9ff;
  background: #eff4ff;
  color: #00236f;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
}

.inlineDateEditorBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-top: 0.25rem;
}

.inlineDateInput {
  background: #ffffff;
  color: #0d1c2e;
  border: 1px solid #00236f;
  border-radius: 6px;
  padding: 0.26rem 0.48rem;
  font-family: var(--font-mono, monospace);
  font-size: 0.76rem;
  font-variant-numeric: tabular-nums;
}

.inlineDateSaveBtn {
  padding: 0.26rem 0.55rem;
  border-radius: 6px;
  border: none;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
}

.inlineDateCancelBtn {
  padding: 0.26rem 0.55rem;
  border-radius: 6px;
  border: 1px solid #c5c5d3;
  background: #ffffff;
  color: #444651;
  font-size: 0.72rem;
  cursor: pointer;
}

.emptyExpensesNotice {
  background: #f8f9ff;
  border: 1px dashed #c5c5d3;
  border-radius: 10px;
  padding: 1.15rem;
  text-align: center;
  font-size: 0.82rem;
  color: #444651;
  line-height: 1.45;
}

.expenseRight {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  flex-shrink: 0;
}

.expenseAmount {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1rem;
  font-weight: 800;
  color: #ba1a1a;
  font-variant-numeric: tabular-nums;
}

.expenseImpactTag {
  font-size: 0.71rem;
  color: #004469;
  font-weight: 700;
  font-family: var(--font-mono, monospace);
  font-variant-numeric: tabular-nums;
}

.expenseActionsRow {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 0.2rem;
}

.viewReceiptBtnPrimary {
  padding: 0.28rem 0.62rem;
  border-radius: 6px;
  border: 1px solid #00236f;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-size: 0.71rem;
  font-weight: 700;
  cursor: pointer;
}

.viewDetailBtnSecondary {
  padding: 0.28rem 0.62rem;
  border-radius: 6px;
  border: 1px solid #dce9ff;
  background: #eff4ff;
  color: #00236f;
  font-size: 0.71rem;
  font-weight: 700;
  cursor: pointer;
}

.deleteExpenseBtn {
  padding: 0.28rem 0.56rem;
  border-radius: 6px;
  border: 1px solid #ffdad6;
  background: #fff5f5;
  color: #ba1a1a;
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
}

.lineItemsSublist {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.38rem;
  padding-top: 0.35rem;
  border-top: 1px dashed #dce9ff;
}

.lineItemsLabel {
  font-size: 0.7rem;
  font-weight: 700;
  color: #444651;
}

.lineItemChip {
  font-size: 0.71rem;
  color: #0d1c2e;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 6px;
  padding: 0.16rem 0.48rem;
  word-break: break-word;
  font-variant-numeric: tabular-nums;
}

/* Modal de Detalle Completo del Gasto y Visor de Boleta Escaneada (Sapphire Institutional Clarity) */
.receiptModalBackdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(13, 28, 46, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow-y: auto;
}

.receiptModalDialog {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 18px;
  width: 100%;
  max-width: 980px;
  max-height: 92vh;
  overflow-y: auto;
  padding: 1.25rem 1.4rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0 24px 64px rgba(13, 28, 46, 0.22);
}

.receiptModalHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.85rem;
  flex-wrap: wrap;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #dce9ff;
}

.receiptModalTitleGroup {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}

.receiptModalEyebrow {
  font-size: 0.7rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #006a61;
}

.receiptModalTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.18rem;
  font-weight: 800;
  color: #00236f;
  margin: 0;
  letter-spacing: -0.02em;
}

.receiptModalHeaderRight {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.receiptModalAmountBadge {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 1.08rem;
  font-weight: 800;
  color: #ba1a1a;
  background: #ffdad6;
  border: 1px solid #ffb4ab;
  border-radius: 8px;
  padding: 0.32rem 0.75rem;
  font-variant-numeric: tabular-nums;
}

.receiptModalCloseBtn {
  background: #eff4ff;
  color: #00236f;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  padding: 0.42rem 0.85rem;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
}

.receiptModalCloseBtn:hover {
  background: #e6eeff;
  border-color: #00236f;
}

.receiptModalBodyGrid {
  display: grid;
  grid-template-columns: 1fr 1.15fr;
  gap: 1.1rem;
  align-items: start;
}

.receiptModalImagePanel,
.receiptModalDetailsPanel {
  background: #f8f9ff;
  border: 1px solid #dce9ff;
  border-radius: 14px;
  padding: 1rem 1.1rem;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-width: 0;
}

.receiptModalSectionHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.receiptModalSectionTitle {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.82rem;
  font-weight: 800;
  color: #00236f;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.receiptImageControls {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.receiptZoomBtn,
.receiptDownloadLink {
  background: #ffffff;
  border: 1px solid #dce9ff;
  color: #00236f;
  border-radius: 6px;
  padding: 0.25rem 0.55rem;
  font-size: 0.71rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.receiptZoomBtn:hover,
.receiptDownloadLink:hover {
  background: #eff4ff;
  border-color: #00236f;
}

.receiptFullImageViewport {
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 460px;
  overflow: auto;
}

.receiptFullImageViewportZoomed {
  max-height: 600px;
  align-items: flex-start;
  justify-content: flex-start;
}

.receiptFullImg {
  max-width: 100%;
  max-height: 430px;
  object-fit: contain;
  border-radius: 6px;
  cursor: zoom-in;
}

.receiptFullImgZoomed {
  width: 175%;
  max-width: none;
  height: auto;
  border-radius: 6px;
  cursor: zoom-out;
}

.noReceiptImageBox {
  background: #ffffff;
  border: 1px dashed #c5c5d3;
  border-radius: 10px;
  padding: 1.4rem 1rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
}

.noReceiptIcon {
  font-size: 2rem;
}

.noReceiptTitle {
  font-size: 0.84rem;
  font-weight: 700;
  color: #0d1c2e;
  margin: 0;
}

.noReceiptSubtitle {
  font-size: 0.75rem;
  color: #444651;
  margin: 0;
  line-height: 1.4;
}

.attachReceiptBar {
  display: flex;
  justify-content: center;
}

.attachReceiptLabelBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.55rem 0.85rem;
  border-radius: 8px;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  color: #00236f;
  font-size: 0.78rem;
  font-weight: 800;
  cursor: pointer;
  text-align: center;
}

.attachReceiptLabelBtn:hover {
  background: #e6eeff;
  border-color: #00236f;
}

.detailFieldsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
}

.detailFieldCard {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  padding: 0.52rem 0.7rem;
  display: flex;
  flex-direction: column;
  gap: 0.14rem;
}

.detailFieldCardFull,
.editExpenseSection {
  grid-column: 1 / -1;
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  padding: 0.52rem 0.7rem;
  display: flex;
  flex-direction: column;
  gap: 0.14rem;
}

.detailFieldLabel {
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #444651;
}

.detailFieldValue {
  font-size: 0.82rem;
  font-weight: 700;
  color: #0d1c2e;
  word-break: break-word;
}

.detailFieldValueMono {
  font-size: 0.82rem;
  font-weight: 700;
  color: #00236f;
  font-family: var(--font-mono, monospace);
  font-variant-numeric: tabular-nums;
  word-break: break-word;
}

.modalImpactBanner,
.modalImpactSummaryBox {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.55rem;
  background: #eff4ff;
  border: 1px solid #dce9ff;
  border-radius: 10px;
  padding: 0.65rem 0.75rem;
}

.modalImpactCol {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.modalImpactAmount {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.94rem;
  font-weight: 800;
  color: #ba1a1a;
  font-variant-numeric: tabular-nums;
}

.modalImpactWarning {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.9rem;
  font-weight: 800;
  color: #006a61;
  font-variant-numeric: tabular-nums;
}

.modalImpactInfo {
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.9rem;
  font-weight: 800;
  color: #004469;
  font-variant-numeric: tabular-nums;
}

.modalItemsSection {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.modalItemsTable {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 9px;
  overflow: hidden;
}

.modalItemsHeaderRow {
  display: grid;
  grid-template-columns: 52px 1fr 82px 86px;
  gap: 0.45rem;
  background: #eff4ff;
  padding: 0.45rem 0.65rem;
  font-family: var(--font-display, 'Manrope', sans-serif);
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  color: #00236f;
}

.modalItemsRow {
  display: grid;
  grid-template-columns: 52px 1fr 82px 86px;
  gap: 0.45rem;
  padding: 0.45rem 0.65rem;
  border-top: 1px solid #dce9ff;
  font-size: 0.76rem;
  color: #0d1c2e;
  background: #ffffff;
  align-items: center;
}

.modalItemQty {
  font-family: var(--font-mono, monospace);
  font-weight: 700;
  color: #006a61;
  font-variant-numeric: tabular-nums;
}

.modalItemDesc {
  word-break: break-word;
  color: #0d1c2e;
}

.modalItemUnit,
.modalItemTotal {
  font-family: var(--font-mono, monospace);
  text-align: right;
  font-weight: 700;
  color: #00236f;
  font-variant-numeric: tabular-nums;
}

.modalItemsEmpty {
  background: #ffffff;
  border: 1px solid #dce9ff;
  border-radius: 8px;
  padding: 0.55rem 0.75rem;
  font-size: 0.78rem;
  color: #444651;
}

/* Adaptación Responsiva para Tablets y Vista de Celular */
@media (max-width: 1080px) {
  .kpiSummaryGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .manualFormGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .chartsGrid,
  .productSpotlightGrid,
  .receiptModalBodyGrid {
    grid-template-columns: minmax(0, 1fr);
  }

  .headerCard,
  .chartCard,
  .productImpactSection,
  .ledgerCard,
  .manualExpenseCard,
  .receiptModalDialog {
    padding: 0.95rem;
  }
}

@media (max-width: 640px) {
  .kpiSummaryGrid,
  .manualFormGrid,
  .detailFieldsGrid,
  .modalImpactBanner,
  .modalImpactSummaryBox {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.65rem;
  }

  .periodSelect,
  .manualSubmitBtn,
  .scanShortcutBtn {
    width: 100%;
    min-width: 0;
  }

  .kpiBox {
    padding: 0.75rem 0.85rem;
  }

  .kpiMainValue {
    font-size: 1rem;
  }

  .donutLayout {
    flex-direction: column;
    align-items: stretch;
  }

  .spotlightStatsGrid {
    grid-template-columns: minmax(0, 1fr);
  }

  .filterSelect {
    width: 100%;
  }

  .expenseRowMain {
    flex-direction: column;
    align-items: stretch;
  }

  .receiptThumbColumn {
    align-items: flex-start;
  }

  .receiptThumbButton,
  .receiptPlaceholderButton {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    padding: 0.45rem 0.65rem;
    min-height: auto;
    gap: 0.65rem;
  }

  .receiptThumbImg {
    width: 58px;
    height: 68px;
  }

  .expenseRight {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 0.35rem;
    border-top: 1px solid #dce9ff;
  }

  .modalItemsHeaderRow,
  .modalItemsRow {
    grid-template-columns: 42px 1fr 70px;
  }

  .modalItemUnit {
    display: none;
  }
}

.unassignedCardBadge {
  display: inline-flex;
  align-items: center;
  font-size: 0.66rem;
  font-weight: 700;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 5px;
  padding: 0.1rem 0.44rem;
}

.quickAssignCardSelect {
  background: #ffffff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 6px;
  padding: 0.16rem 0.42rem;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
}

.editExpenseRowBtn {
  padding: 0.28rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #dce9ff;
  background: #f8f9ff;
  color: #00236f;
  font-size: 0.7rem;
  font-weight: 700;
  cursor: pointer;
}

.editExpenseRowBtn:hover {
  background: #eff4ff;
  border-color: #00236f;
}

.editDetailToggleBtn {
  padding: 0.3rem 0.65rem;
  border-radius: 6px;
  border: 1px solid #dce9ff;
  background: #ffffff;
  color: #00236f;
  font-size: 0.74rem;
  font-weight: 800;
  cursor: pointer;
}

.editDetailToggleBtn:hover {
  background: #eff4ff;
  border-color: #00236f;
}

.saveDetailEditsBtn {
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  border: none;
  background: linear-gradient(135deg, #00236f 0%, #1e3a8a 100%);
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 800;
  cursor: pointer;
}

.cancelDetailEditsBtn {
  padding: 0.35rem 0.7rem;
  border-radius: 6px;
  border: 1px solid #c5c5d3;
  background: #ffffff;
  color: #444651;
  font-size: 0.74rem;
  font-weight: 700;
  cursor: pointer;
}

.detailFieldEditInput,
.detailFieldEditSelect {
  width: 100%;
  background: #f8f9ff;
  color: #0d1c2e;
  border: 1px solid #c5c5d3;
  border-radius: 6px;
  padding: 0.34rem 0.5rem;
  font-size: 0.78rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.detailFieldEditInput:focus,
.detailFieldEditSelect:focus {
  outline: none;
  background: #ffffff;
  border-color: #00236f;
  box-shadow: 0 0 0 3px rgba(0, 35, 111, 0.1);
}

.detailEditActionsBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.55rem;
  flex-wrap: wrap;
}
